function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { applyDropdownListCssProperties } from '../Dropdown';
import { SelectView } from './SelectView';
import { withSingleSelect } from './withSingleSelect';
import { withMultiSelect } from './withMultiSelect';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Select/Select');
var StyledSelectView = /*#__PURE__*/styled(SelectView).withConfig({
  componentId: "plasma-web-core__sc-m9l8to-0"
})(["", ";"], applyDropdownListCssProperties);
var SingleSelect = /*#__PURE__*/withSingleSelect(StyledSelectView);
var MultiSelect = /*#__PURE__*/withMultiSelect(StyledSelectView);
export var Select = function Select(_ref) {
  var design = _ref.design;
  return /*#__PURE__*/forwardRef(function (props, ref) {
    if (props.multiselect) {
      return /*#__PURE__*/React.createElement(MultiSelect, _extends({
        design: design,
        ref: ref
      }, props));
    }

    return /*#__PURE__*/React.createElement(SingleSelect, _extends({
      design: design,
      ref: ref
    }, props));
  });
};